<template>
  <question
    prevTitle="Back"
    nextTitle="Next"
    prevEnabled
    :nextEnabled="selected !== 'Please select an industry sector'"
    @prevClick="$router.go(-1)"
    @nextClick="next"
  >
    <div class="rounded shadow">
      <h3 class="panel inverted">Industry Sector</h3>
      <div class="toplined panel">
        <select v-model="selected">
          <option v-for="(item, index) in sectors" :key="index">{{item}}</option>
        </select>
      </div>
    </div>
  </question>
</template>
<style lang="scss" scoped>
.panel {
  padding: 1em;
}
</style>
<script>
import question from "@/components/questionTemplate";

export default {
  props: {
    nextRoute: {
      type: String,
      default: "3"
    }
  },
  components: {
    question
  },
  methods: {
    next: function() {
      this.$store.dispatch("setFormData", {
        sector: this.selected
      });
      this.$router.push(this.nextRoute);
    }
  },
  beforeMount: function() {
    this.selected = this.$store.state.formData.sector;
  },
  data: function() {
    return {
      selected: "Please select an industry sector",
      sectors: [
        "Please select an industry sector",
        "Advertising / Marketing",
        "Beer / Wine Merchant",
        "Builders Merchant",
        "Clothing & Fashion",
        "Computer Hardware",
        "Computer Software",
        "Construction",
        "Plant Hire",
        "Consultancy",
        "Contract Cleaning",
        "Courier",
        "Distribution",
        "Driving Agency",
        "Electrical Contracting",
        "Electrical Wholesaler",
        "Engineering - Heavy",
        "Engineering - Light",
        "Engineering - Precision",
        "Fabrication",
        "Flooring Contractor",
        "Food Manufacture",
        "Franchise",
        "Free Newspaper",
        "Freight Forwarding",
        "Fruit Importer",
        "Furniture Manufacture",
        "Garden Equipment",
        "Haulage",
        "IT Contracting",
        "Jewellery",
        "Maintenance",
        "Manufacturing",
        "Meat Trade",
        "Other Services",
        "Permanent Recruitment",
        "Plant Hire",
        "Plastic Injection Moulding",
        "Plumbers Merchant",
        "Printing",
        "Publishing",
        "Recycling",
        "Security Guards",
        "Shopfitting",
        "Stationery",
        "Steel Stockholding",
        "Telecoms",
        "Temporary Recruitment",
        "Timber Merchant",
        "Tooling Manufacture",
        "Toys & Fancy Goods",
        "Warehousing & Storage",
        "Wholesale"
      ]
    };
  }
};
</script>